import {useEffect, useState} from "react";
import downIcon from "../../../assets/images/classes/downIcon.svg";

const LicenseSelectClassMenu = ({ classList, selectedClass, setSelectedClass, setIsEditable, selectedIndexList,setSelectedIndexList, setSelectedStudentList, type, setIsModifyCheckModalOpen, changeClass, setChangeClass, setModifyCheckType, mainClass}) => {
    const [isOpen, setIsOpen] = useState(false); // 메뉴 열림 상태
    const [clickedClass, setClickedClass] = useState(null);

    const toggleDropdown = () => {
        setIsOpen((prev) => !prev); // 열림/닫힘 토글
    };

    const selectClass = (item) => {
        if(selectedIndexList && selectedIndexList.length > 0){
            setClickedClass(item);
            setModifyCheckType("changeClass");
            setIsModifyCheckModalOpen(true);
        }else{
            setIsEditable(false);
            setSelectedClass(item);
            if(setSelectedIndexList){
                setSelectedIndexList([]);
            }
            if(setSelectedStudentList){
                setSelectedStudentList([]);
            }
            toggleDropdown();
            setClickedClass(null);
        }
    };

    useEffect(() => {
        if (classList && selectedClass) {
            const updatedClass = classList.find(item => item.classId === selectedClass.classId);
            if (updatedClass) {
                setSelectedClass(updatedClass); // 최신 데이터로 다시 설정
            }
        }
    },[classList, selectedClass])

    // 스크롤 동작 함수
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'auto',
        });
    };

    useEffect (() => {
        if(changeClass && changeClass===true){
            selectClass(clickedClass);
            setChangeClass(false);
        }
    },[changeClass]);

    return (
        <>
                {/* 버튼 */}
                <button
                    onClick={toggleDropdown}
                    className={`inline-flex w-full h-full justify-center items-center gap-x-1.5 transition-all duration-300 ${
                        isOpen ? "rounded-t-[34px] rounded-b-none" : "rounded-[34px]"
                    } bg-white px-3 py-2 text-lg font-bold text-[#355bdf] ring-1 ring-inset ring-gray-300 hover:bg-gray-50 shadow`}
                >
                    <div className="absolute flex flex-row left-0 right-0 text-center text-[20px] justify-center">
                        <div className="max-w-[57%] truncate text-center">
                        {selectedClass && selectedClass.name}&nbsp;
                        </div>
                        <div className="text-[#5E6169]] font-[900]">
                            {selectedClass ? (type==="activeLicense" ?
                            <> ({selectedClass.studentsCount - selectedClass.activeLicenseCount}명)</>
                        :
                            <>
                                <span className="text-[#5E6169]">(</span>
                                <span className="text[#355bdf]">{selectedClass.activeLicenseCount}</span>
                                <span className="text-[14px]">명</span>
                                <span className="text-[#5E6169] text-[20px]">/{selectedClass.studentsCount}
                                    <span className="text-[14px]">명</span>
                                    <span>)</span>
                                </span>
                            </>
                        ) : <span>0명</span>}
                        </div>
                    </div>
                    <img
                        src={downIcon}
                        alt="downIcon"
                        className="ml-auto mr-[12px]"
                    />
                </button>

                {/* 드롭다운 메뉴 */}
                <div
                    className={`absolute w-full z-10 origin-top rounded-b-[34px] bg-white shadow-lg ring-1 ring-black/5 transition-all duration-300 overflow-hidden ${
                        isOpen ? "max-h-[300px] opacity-100" : "max-h-0 opacity-0"
                    }`}
                    style={{
                        transformOrigin: "top", // 애니메이션 시작점 설정
                    }}
                >

                    <div className="px-3 pt-1 pb-2 max-h-[300px] overflow-y-auto">
                        {classList && classList.map((item, index) => (
                            <div
                                key={index}
                                className={`flex flex-row justify-between h-[60px] items-center cursor-pointer hover:bg-gray-100 ${item && selectedClass && item.classId===selectedClass.classId? 'bg-[#EEF6FF]' : ''}`}
                                onClick={() => selectClass(item)}
                            >
                                <div className="text-[13px] font-normal pl-1 w-[54px]">
                                    {item.registerDate}
                                </div>
                                <div
                                    className="block px-4 py-2 text-lg max-w-[400px] truncate"
                                >
                                    {item.name}
                                </div>
                                <div
                                    className="text-[13px] font-normal pr-1  w-[54px] text-right"
                                >
                                    {type && type==="activeLicense" ?
                                        item.studentsCount - item.activeLicenseCount
                                        : item.activeLicenseCount + "/" + item.studentsCount}명
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
        </>
    );
};

export default LicenseSelectClassMenu;
